export default __webpack_public_path__ + "static/media/OccupyMachine.cd94e085.pdf";